const DEFAULT_STAFF_IDS = {
  MICROSERVICES: {
    STAFF_ID: '-9',
    ENV_VAR: 'REACT_APP_MICROSERVICES_STAFF_ID'
  },
  REFERRALS_PARTICIPANT: {
    STAFF_ID: '-11',
    ENV_VAR: 'REACT_APP_REFERRALS_PARTICIPANT_STAFF_ID'
  },
  ASSESSMENTS: {
    STAFF_ID: '-12',
    ENV_VAR: 'REACT_APP_ASSESSMENTS_STAFF_ID'
  }
}

function getServiceStaffId(envVar, defaultId) {
  const idFromEnv = process.env[envVar];
  if (idFromEnv) {
    return idFromEnv;
  }
  return defaultId;
}

export function getMicroserviceStaffId() {
  return getServiceStaffId(DEFAULT_STAFF_IDS.MICROSERVICES.ENV_VAR, DEFAULT_STAFF_IDS.MICROSERVICES.STAFF_ID)
}

export function getReferralsParticipantServiceStaffId() {
  return getServiceStaffId(DEFAULT_STAFF_IDS.REFERRALS_PARTICIPANT.ENV_VAR, DEFAULT_STAFF_IDS.REFERRALS_PARTICIPANT.STAFF_ID)
}

export function getAssessmentsServiceStaffId() {
  return getServiceStaffId(DEFAULT_STAFF_IDS.ASSESSMENTS.ENV_VAR, DEFAULT_STAFF_IDS.ASSESSMENTS.STAFF_ID)
}

/*
NOTE: More system user functions can be added here as needed, but these are the only ones currently in use.
*/